import { forwardRef } from 'react';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Input } from './';
import { cn } from '../../utils/cn';
import ScanService from '../../services/ScanService';

const SearchBar = forwardRef(({
	searchTerm = '',
	onSearchChange,
	onPlatformFilter,
	onSort,
	selectedPlatform = '',
	sortBy = 'name',
	sortOptions = [
		{ value: 'name', label: 'Name' },
		{ value: 'date', label: 'Date' },
	],
	// Derived so the filter can never offer a platform that cannot be scanned.
	platformOptions = ScanService.getEnabledPlatforms().map((p) => p.short),
	searchPlaceholder = 'Search...',
	showFilters = true,
	className,
	...props
}, ref) => {
	const handleSearchChange = (e) => {
		onSearchChange?.(e.target.value);
	};

	const handlePlatformChange = (e) => {
		onPlatformFilter?.(e.target.value);
	};

	const handleSortChange = (e) => {
		onSort?.(e.target.value);
	};

	return (
		<div
			ref={ref}
			className={cn("w-full flex flex-col gap-4", className)}
			{...props}
		>
			<div className="flex items-center justify-between">
				{/* Search Input */}
				<div className="flex items-center bg-accent rounded-lg px-4 py-3 gap-3 flex-1 max-w-[600px]">
					<MagnifyingGlassIcon className="w-5 h-5 text-muted-foreground" />
					<Input
						type="text"
						placeholder={searchPlaceholder}
						value={searchTerm}
						onChange={handleSearchChange}
						variant="ghost"
						className="border-0 bg-transparent text-foreground placeholder-muted-foreground focus:ring-0"
					/>
				</div>
			</div>

			{/* Filter Controls */}
			{showFilters && (
				<div className="flex items-center gap-4 flex-wrap">
					{/* Platform Filter */}
					<div className="flex items-center gap-2">
						<label className="text-sm font-medium text-foreground">Platform:</label>
						<select
							value={selectedPlatform}
							onChange={handlePlatformChange}
							className="h-8 px-3 rounded-md border border-input text-sm focus:border-brand-500 focus:ring-0"
						>
							<option value="">All Platforms</option>
							{platformOptions.map((platform) => (
								<option key={platform} value={platform}>
									{platform}
								</option>
							))}
						</select>
					</div>

					{/* Sort Filter */}
					<div className="flex items-center gap-2">
						<label className="text-sm font-medium text-foreground">Sort by:</label>
						<select
							value={sortBy}
							onChange={handleSortChange}
							className="h-8 px-3 rounded-md border border-input text-sm focus:border-brand-500 focus:ring-0"
						>
							{sortOptions.map((option) => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</select>
					</div>
				</div>
			)}
		</div>
	);
});

SearchBar.displayName = "SearchBar";

export { SearchBar }; 